(() => {
  'use strict';

  const p2 = window.CoastalSoulP2;
  if (!p2) return;

  const { normalize, findTextElement } = p2;

  const questionCta = ({
    pageKey,
    eyebrow = 'Ask Chef Marvin',
    heading = 'Bring your cooking question to the table.',
    copy = 'Questions are reviewed in one place so Chef Marvin can turn the strongest ones into useful recipes, articles, and videos.',
    showAsk = true,
    showJoin = true
  }) => {
    const section = document.createElement('section');
    section.className = 'p2-question-cta';
    section.id = `p2-question-cta-${pageKey}`;
    section.setAttribute('aria-labelledby', `p2-question-cta-title-${pageKey}`);
    section.dataset.sourceSection = 'at-the-table-question-cta';

    const actions = [];
    if (showAsk) {
      actions.push(
        '<a class="p2-question-cta__button" href="/pages/at-the-table#ask-chef-marvin">Ask Chef Marvin</a>'
      );
    }
    if (showJoin) {
      actions.push(
        '<a class="p2-question-cta__button p2-question-cta__button--secondary" href="/pages/at-the-table#join-the-table">Join the Table</a>'
      );
    }

    section.innerHTML = `
      <div class="p2-question-cta__inner">
        ${eyebrow ? `<p class="p2-question-cta__eyebrow">${eyebrow}</p>` : ''}
        <h2 class="p2-question-cta__title" id="p2-question-cta-title-${pageKey}">${heading}</h2>
        <p class="p2-question-cta__copy">${copy}</p>
        ${actions.length ? `<div class="p2-question-cta__actions">${actions.join('')}</div>` : ''}
      </div>`;

    return section;
  };

  const replaceDuplicateQuestionForm = (root, pageKey) => {
    if (document.getElementById(`p2-question-cta-${pageKey}`)) return true;

    let oldSection = root.querySelector('[id*="contact_form_m3abC4"]');

    if (!oldSection) {
      const usefulPages = findTextElement(root, 'Useful pages');
      oldSection = usefulPages?.closest('[id^="shopify-section-"], section');
    }

    if (!oldSection) return false;
    oldSection.replaceWith(questionCta({ pageKey }));
    return true;
  };

  const insertJoinCta = (root, pageKey) => {
    if (document.getElementById(`p2-question-cta-${pageKey}`)) return true;

    const cta = questionCta({
      pageKey,
      eyebrow: '',
      heading: 'Join the Table',
      copy: 'Get new recipes, videos, articles, and answers from Chef Marvin.',
      showAsk: false,
      showJoin: true
    });

    const episodeTitle =
      findTextElement(root, 'Episode 3', 'h1, h2, h3, h4, h5, p, a, span') ||
      findTextElement(root, 'The Receipts', 'h1, h2, h3, h4, h5');
    const episodeSection = episodeTitle?.closest('[id^="shopify-section-"], section');

    if (episodeSection && episodeSection.parentElement) {
      episodeSection.insertAdjacentElement('afterend', cta);
    } else {
      root.append(cta);
    }

    return true;
  };

  const ensureCatalogList = (root) => {
    const exactCatalog = 'Rise & Roll, After Dark, Bowl Life, and All Good';
    const oldCatalog = 'Rise & Roll, Bowl Life, Weeknight, and After Dark';

    const oldElement = findTextElement(root, oldCatalog, 'p, li, div, span');
    if (oldElement) {
      oldElement.textContent = exactCatalog;
      oldElement.dataset.p2CatalogList = 'true';
      return true;
    }

    if (root.querySelector('[data-p2-catalog-list]')) return true;

    const reference =
      findTextElement(root, 'Digital Recipe', 'h1, h2, h3, h4, p, a') ||
      findTextElement(root, 'Rise & Roll', 'h1, h2, h3, h4, p, a');
    const catalogSection = reference?.closest('[id^="shopify-section-"], section');
    if (!catalogSection) return false;

    const paragraph = document.createElement('p');
    paragraph.className = 'p2-catalog-list';
    paragraph.dataset.p2CatalogList = 'true';
    paragraph.textContent = exactCatalog;
    catalogSection.append(paragraph);
    return true;
  };

  Object.assign(p2, {
    questionCta,
    replaceDuplicateQuestionForm,
    insertJoinCta,
    ensureCatalogList
  });
})();
